import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {handleRepositoryDataError} from '@github-ui/data-router-error-helpers'
import {RepositoryLabelsInternal} from '@github-ui/repository-label/RepositoryLabels'

import {labelsRoute} from './labels-route'

export function Labels() {
  const payload = useRouteQuery(labelsRoute, 'mainQuery')

  // on FORBIDDEN/SAML this reloads the page; otherwise it throws to the error boundary
  const data = handleRepositoryDataError(payload.data)
  // data is undefined only while a FORBIDDEN/SAML reload is in flight; render nothing until it lands
  if (!data?.repository) {
    return null
  }

  return <RepositoryLabelsInternal repository={data.repository} queryKey={payload.queryKey} />
}
